<rid-reading-matrix-categorise
  class="h-dvh"
  category="fruit"
  [matrix]="[
    [
      { word: 'appel', isCorrect: true },
      { word: 'aan', isCorrect: false },
      { word: 'gaaf', isCorrect: false },
      { word: 'mos', isCorrect: false },
      { word: 'gum', isCorrect: false },
      { word: 'maat', isCorrect: false },
    ],
    [
      { word: 'guur', isCorrect: false },
      { word: 'ijs', isCorrect: false },
      { word: 'jaar', isCorrect: false },
      { word: 'jas', isCorrect: false },
      { word: 'lees', isCorrect: false },
      { word: 'kers', isCorrect: true },
    ],
    [
      { word: 'aai', isCorrect: false },
      { word: 'banaan', isCorrect: true },
      { word: 'gaaf', isCorrect: false },
      { word: 'mos', isCorrect: false },
      { word: 'gum', isCorrect: false },
      { word: 'goor', isCorrect: false },
    ],
  ]"
  (finished)="$router.navigate(['/mechanics/reading-matrix'])"
/>
